import { render, staticRenderFns } from "./PavementDashboard.vue?vue&type=template&id=56cdf76e"
import script from "./PavementDashboard.vue?vue&type=script&lang=js"
export * from "./PavementDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports